var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFe6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1435_12173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.65996 20.16C2.23996 20.16 1.86996 19.85 1.81996 19.42C1.74996 18.85 1.70996 18.27 1.70996 17.68C1.70996 12.05 5.01996 6.93 10.15 4.63C10.58 4.44 11.08 4.63 11.27 5.06C11.46 5.49 11.27 5.99 10.84 6.18C6.32996 8.2 3.40996 12.72 3.40996 17.68C3.40996 18.2 3.43996 18.71 3.50996 19.2C3.56996 19.67 3.23996 20.09 2.76996 20.15C2.72996 20.15 2.68996 20.16 2.65996 20.16Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.0298 31.9999C13.1098 31.9999 10.2998 31.1299 7.91977 29.4799C7.52977 29.2099 7.43977 28.6799 7.69977 28.2999C7.96977 27.9099 8.49977 27.8199 8.87977 28.0799C10.9798 29.5299 13.4498 30.2999 16.0198 30.2999C18.5798 30.2999 21.0398 29.5399 23.1298 28.0999C23.5198 27.8399 24.0498 27.9299 24.3098 28.3199C24.5798 28.7099 24.4798 29.2399 24.0898 29.4999C21.7298 31.1399 18.9298 31.9999 16.0298 31.9999Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.4097 20.18C29.3697 20.18 29.3397 20.18 29.2997 20.17C28.8297 20.11 28.4997 19.69 28.5597 19.22C28.6197 18.71 28.6597 18.2 28.6597 17.67C28.6597 12.71 25.7397 8.18999 21.2297 6.16999C20.7997 5.97999 20.6097 5.46999 20.7997 5.04999C20.9897 4.61999 21.4897 4.42999 21.9197 4.61999C27.0397 6.91999 30.3597 12.04 30.3597 17.67C30.3597 18.27 30.3197 18.85 30.2497 19.43C30.1997 19.86 29.8297 20.18 29.4097 20.18Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.0298 8.39C13.7198 8.39 11.8398 6.51 11.8398 4.2C11.8398 1.89 13.7098 0 16.0298 0C18.3398 0 20.2198 1.88 20.2198 4.19C20.2198 6.5 18.3398 8.39 16.0298 8.39ZM16.0298 1.7C14.6598 1.7 13.5398 2.82 13.5398 4.19C13.5398 5.56 14.6598 6.68 16.0298 6.68C17.4098 6.68 18.5198 5.56 18.5198 4.19C18.5198 2.82 17.3998 1.7 16.0298 1.7Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M27.4898 28.86C25.1798 28.86 23.2998 26.98 23.2998 24.67C23.2998 22.36 25.1798 20.48 27.4898 20.48C29.7998 20.48 31.6798 22.36 31.6798 24.67C31.6798 26.98 29.7998 28.86 27.4898 28.86ZM27.4898 22.17C26.1198 22.17 24.9998 23.29 24.9998 24.66C24.9998 26.04 26.1198 27.15 27.4898 27.15C28.8698 27.15 29.9798 26.03 29.9798 24.66C29.9798 23.29 28.8598 22.17 27.4898 22.17Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.50982 28.86C2.19982 28.86 0.319824 26.98 0.319824 24.67C0.319824 22.36 2.19982 20.48 4.50982 20.48C6.81982 20.48 8.69982 22.36 8.69982 24.67C8.69982 26.98 6.81982 28.86 4.50982 28.86ZM4.50982 22.17C3.13982 22.17 2.01982 23.29 2.01982 24.66C2.01982 26.04 3.13982 27.15 4.50982 27.15C5.87982 27.15 6.99982 26.04 6.99982 24.67C6.99982 23.29 5.88982 22.17 4.50982 22.17Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1435_12173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFe6);
export default __webpack_public_path__ + "static/media/fe-6.67a4eaf3bd4362e3e6138dd68928b99b.svg";
export { ForwardRef as ReactComponent };